<template>
<div class="subject-box">
  <div class="subject-box-title">
    <div class="title-left">
      <p class="china-title">{{currentQuestionList1.tips_cnname}}</p>
      <p class="en-title">{{currentQuestionList1.tips_enname}}</p>
    </div>
    <div class="title-right" v-if="currentQuestionList1.has_audio==1">
      <div class="audio-add" @click="playAudio">
        <div class="audio-box" style="position:relative;z-index:10;"></div>
        <audio class="audio" id="audioPlay" ref="audio" controls :src="currentQuestionList1.question_audio" autoplay ></audio>
      </div>
    </div>
  </div>
  <div class="subject-content-box">
    <!-- 填空题 (文上空下) -->
    <div class="subject-content fillBlank" v-if="currentQuestionList1.category_id==15">
      <div class="word-box" v-html="currentQuestionList1.question_title"></div>
      <div class="isHasImg" v-if="currentQuestionList1.has_img==1">
        <img :src="currentQuestionList1.question_titleimg" style="max-width: 300px;" />
      </div>
      <div class="fill-box">
        <div class="item">
          <p class="item-fill item-fill-top">
            <span v-html="currentQuestionList1.question_content"></span>
            <input type="text" class="ipt" v-model="anwsersAll.answers" 
            @change="fillText(currentQuestionList1.question_id)" />
            <!-- <input type="text" v-model="${answerList[0].answer[i]}"> -->
          </p>
        </div>
      </div>
    </div>
    <!-- 填空题(字母/单词填充) -->
    <div class="subject-content fillBlank" v-if="currentQuestionList1.category_id==16">
      <div class="word-box" v-html="currentQuestionList1.question_title"></div>
      <div class="isHasImg" v-if="currentQuestionList1.has_img==1">
        <img :src="currentQuestionList1.question_titleimg" alt />
      </div>
      <div class="fill-box">
        <div class="item">
          <p class="item-fill item-fill-unit">
            <span v-for="(item,index) of transformValue" :key="index" :class="`fill-${item.myVlue}`">
              <input v-if="item.myVlue == '我是input'" type="text" class="ipt" v-model="anwsersAll.answers[item.indexMy]" @change="fillMilte(currentQuestionList1.question_id)" >
              <p v-else-if="item.myVlue == 'brand'" style="display:block;"></p>
              <span v-else>{{item.myVlue}}</span>
            </span>
            <!-- <input type="text" class="ipt" v-model="picked1"> -->
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "FillBlank",
  props: {
    currentQuestionList: {
      type: Object
    },
    anwsersAll: {
      type: Object
    },
     propIndex:{
      type: Number
    },
    propChild: {
      type: Object
    },
  },
  data() {
    return {
      currentQuestionList1: {},
      transformValue: [],
      picked: [],
      picked1: ['1', '3'],
      question: {
        word: "Chevady:Wake up，Matt.<br/>Matt:$B$<br/>Chevady:It is Saturday!Let is go out and play.",
        list: [{
            id: 0,
            value: "A:What is this?",
            option: "A"
          },
          {
            id: 1,
            value: "B: It is a ($)",
            option: "B"
          }
          // {
          //   id: 2,
          //   value: "C:Goodbye.",
          //   option: "C"
          // },
          // {
          //   id: 3,
          //   value: "D:Happy birthday.",
          //   option: "D"
          // }
        ],
        Index: -1,
        flag: false
      },
      answerList: [{
        answer: []
      }]
    };
  },
  watch: {
    getData(n, o) {
      console.log(22222);
      // console.log(n, o,'我接收到的数据');
      this.currentQuestionList1 = n;
      let str = n.question_content;
      this.transformValue = this.questionWay(str);
      let _this = this;
      let myIndex = 0;
      let myIndexReplace = 0;
      this.transformValue.forEach(function(item,index){
        console.log(index)
        if(item.myVlue == '我是input'){
          console.log(myIndex,'我是index')
          console.log(_this.transformValue[index])
            _this.transformValue[index].indexMy = myIndex;
             myIndex++;
          // _this.anwsersAll.answers.push('')
        }
      })
      console.log(myIndex,'我是index')
      console.log(this.transformValue,'新的数据')
      console.log(this.anwsersAll.answers)
      console.log(this.currentQuestionList1, "我接收到的数据");
    },
    getData1(n, o) {
      console.log(22222);
      // console.log(n, o,'我接收到的数据');
      this.currentQuestionList1 = n;
      let str = n.question_content;
      this.transformValue = this.questionWay(str);
      let _this = this;
      let myIndex = 0;
      this.transformValue.forEach(function(item,index){
        console.log(index)
        if(item == '我是input'){
            myIndex++;
            
          // _this.anwsersAll.answers.push('')
        }
      })
      console.log(myIndex,'我是index')
      console.log(this.anwsersAll.answers)
      // anwsersAll.answers
      console.log(this.currentQuestionList1, "我接收到的数据");
    }
  },
  computed: {
    getData() {
      return this.currentQuestionList;
    },
    getData1() {
      return this.propChild;
    },
  },
  created() {
    console.log(this.propChild, "我接收到的数据");
    this.currentQuestionList1 = this.propChild?this.propChild:this.currentQuestionList;
  },
  // props: ['title'],
  methods: {
    //正则转换
    questionWay(stringVal) {
      console.log(stringVal);
      let stringslist = stringVal;
  
      // 填空题
      let regAll = /(\(\$\))|(\(#\))/g;
      let regAll1 = /(\r\n)|(\r)|((\n))/g;
      let matchs = stringVal.match(regAll); //$的匹配
      let matchs1 = stringVal.match(regAll1); //回车符的匹配
      console.log(matchs, '$的匹配')
      console.log(typeof matchs, '$的匹配 的类型')

      if (matchs && matchs.length > 0) {
        console.log(this.anwsersAll.answers)
        // let answers = this.anwsersAll.answers;
        for (let key in matchs) {
          let index = parseInt(key)
          let id = this.currentQuestionList1.question_id;
          stringVal = stringVal.replace(
            matchs[key],
            "我是插入的我是input我是插入的"
          );
        }

        console.log(matchs, "匹配成功");
      }
      if (matchs1 && matchs1.length > 0) {
        stringVal = stringVal.replace(regAll1, "我是插入的brand我是插入的");
        console.log(matchs, "匹配成功");
        console.log(matchs1, "匹配成功");
      }

      console.log(stringVal, "匹配成功之后");
      let strsObj = stringVal;
      let strsObj1 = stringVal.split('我是插入的');//字符串数组 - 转化为对象数组
      let myObjArr = [];
      strsObj1.forEach(function(item,index){
        let obj = {
          myVlue:item
        }
        myObjArr.push(obj)
      })
      console.log(myObjArr)
      
      return myObjArr;
    },
    playAudio() {
      console.log(333);
      let audio = this.$refs.audio;
      audio.play();
    },
    // 填空题 (文上空下) 
    fillText(v1){
      this.$emit('fillText', v1)
    },
    //填空题(字母/单词填充) 
    fillMilte(v1){
      console.log(v1,'填空题(字母/单词填充)' )
      this.$emit('fillMilte', v1)
    },
    clickq() {
      let arr = document.querySelectorAll('.pickIpt');
      console.log(arr)
      arr.forEach(function (element, index) {
        console.log(element, index)
        console.log(element.value)
      });
      console.log(document.querySelectorAll('.pickIpt'))

      // console.log(this.picked1)
    }
  }
};
</script>

<style lang="less">
</style>
